var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3H4.8C3.81 3 3 3.81 3 4.8v14.4c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V4.8c0-.99-.81-1.8-1.8-1.8zM8.4 18.3H5.7v-8.1h2.7v8.1zM7.05 8.67c-.9 0-1.62-.72-1.62-1.62 0-.9.72-1.62 1.62-1.62.9 0 1.62.72 1.62 1.62 0 .9-.72 1.62-1.62 1.62zM18.3 18.3h-2.7v-4.77c0-.72-.63-1.35-1.35-1.35-.72 0-1.35.63-1.35 1.35v4.77h-2.7v-8.1h2.7v1.08c.45-.72 1.44-1.26 2.25-1.26 1.71 0 3.15 1.44 3.15 3.15v5.13z",
    fill: "#2C3032",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "88bcaa31da312c7f9643a699558e543b.svg";
export { SvgIconLinkedin as ReactComponent };